import * as Sentry from "@sentry/react";

const initSentry = (dsn, env) => {

	if (env !== 'production' || !dsn) {
		return;
	}

	Sentry.init({
		dsn,
		sendDefaultPii: true,
		integrations: [Sentry.browserTracingIntegration()],
		tracesSampleRate: 0.1,
	});
};

const setSentryUser = (user) => {
	Sentry.setUser(user);
};

const setSentryTag = (key, value) => {
	Sentry.setTag(key, value);
};

const addSentryBreadcrumb = (breadcrumb) => {
	Sentry.addBreadcrumb(breadcrumb);
};

const captureApiError = (error, context = {}) => {
	const normalizedError = error instanceof Error
		? error
		: new Error(context.message || 'Unknown API error');

	Sentry.captureException(normalizedError, {
		extra: {
			...context,
		},
	});
};

export {
	Sentry,
	initSentry,
	setSentryUser,
	setSentryTag,
	addSentryBreadcrumb,
	captureApiError,
};
